export default __webpack_public_path__ + "static/media/sort-down.5e92537b.svg";